<template>
  <div class="mb10">
    <table class="w-100">
      <tr class="bg-kplh-primary text-white">
        <td rowspan="2" class="col-1">NO</td>
        <td rowspan="2" class="col-5">PERSYARATAN</td>
        <td class="col-1">BOBOT</td>
        <td class="col-1">NILAI</td>
        <td rowspan="3" class="col-4">PENJELASAN HASIL PENILAIAN</td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td>{{ bobot }}</td>
        <td>{{ totalNilai }}</td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">A</td>
        <td class="col-5">KEBIJAKAN, KEPEMIMPINAN & KOMITMEN</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan Kebijakan perusahaan tentang Keselamatan
          Pertambangan dan Lingkungan Hidup / Health, Safety & Environmental
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_a_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_a_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan catatan / bukti komunikasi Kebijakan kepada pekerja baik
          pekerja baru maupun pekerja lama
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_a_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_a_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">B</td>
        <td class="col-5">MANAJEMEN RISIKO</td>
        <td class="col-1">10</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan prosedur yang mengatur proses manajemen risiko
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil analisa risiko yang terakhir
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          "Lampirkan salinan contoh tindak lanjut dari hasil analisa risiko.
          (Contoh: Hasil analisa risiko ditindaklanjuti dengan pembuatan
          prosedur atau dimasukkan dalam program kerja, dll.)"
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan 2 (dua) contoh salinan Analisa Keselamatan Kerja / JSA
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_4', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">C</td>
        <td class="col-5">
          PERATURAN PERUNDANGAN DAN PERSYARATAN LAINNYA (P3L)
        </td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur tentang peraturan perundangan dan persyaratan
          lainnya (P3L)?
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_c_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_c_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan hasil evaluasi kepatuhan perusahaan terhadap peraturan
          perundangan dan persyaratan lainnya.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_c_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_c_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">D</td>
        <td class="col-5">TUJUAN, SASARAN & PROGRAM KPLH</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan program tahunan KPLH / HSE yang terakhir.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_d_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_d_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan hasil evaluasi pencapaian program tahuan KPLH / HSE tahun
          sebelumnya.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_d_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_d_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">E</td>
        <td class="col-5">ORGANISASI DAN SUMBER DAYA</td>
        <td class="col-1">8</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan struktur organisasi yang memiliki tanggung jawab KPLH
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan daftar Tenaga Teknis Pertambangan / Tenaga Teknik Khusus
          yang bertanggung jawab terhadap Keselamatan Operasi atau Keselamatan
          Sarana, Prasarana, Instalasi & Peralatan
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan bukti kompetensi dari personil tersebut
        </td>
        <td class="col-1">4</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">F</td>
        <td class="col-5">KOMPETENSI PEKERJA</td>
        <td class="col-1">11</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan matriks / peta / kamus kompetensi perusahaan
        </td>
        <td class="col-1">4</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil identifikasi kompetensi pekerja terhadap
          matriks / peta / kamus kompetensi yang terakhir
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan rencana pelatihan terkait KPLH tahun terakhir
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan hasil evaluasi pelaksanaan pelatihan dan evaluasi
          efektifitas hasil pelatihan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_4', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">G</td>
        <td class="col-5">KOMUNIKASI</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan program pertemuan KPLH tahun terakhir
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan rapat KPLH (mis. Safety talk) yang dilakukan
          diperusahaan (minimal 3)
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan kehadiran induksi KPLH kepada karyawan (minimal 2)
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">H</td>
        <td class="col-5">TANGGUNG JAWAB KPLH</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan 3 salinan deskripsi pekerjaan / job desc karyawan
        </td>
        <td class="col-1">4</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_h_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_h_1', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">I</td>
        <td class="col-5">IMPLEMENTASI</td>
        <td class="col-1">82</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.1</td>
        <td class="col-5">KAMPANYE</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan proram kampanye tahun terakhir
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i1_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i1_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil evaluasi keefektifan hasil kampanye
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i1_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i1_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.2</td>
        <td class="col-5">INSPEKSI</td>
        <td class="col-1">8</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur terkait inspeksi.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan program inspeksi tahun terakhir
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan salah satu rekomendasi hasil inspeksi dan bukti
          tindaklanjutnya
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan salinan evaluasi hasil kegiatan inspeksi
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_4', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.3</td>
        <td class="col-5">PENGELOLAAN KESEHATAN KERJA</td>
        <td class="col-1">17</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.3.1</td>
        <td class="col-5">PEMERIKSAAN KESEHATAN</td>
        <td class="col-1">8</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan prosedur pengelolaan kesehatan kerja
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i31_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i31_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil pemeriksaan kesehatan awal dan pemeriksaan
          kesehatan berkala untuk satu orang pekerja lapangan
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i31_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i31_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan komunikasi kepada pekerja tentang hasil pemeriksaan
          kesehatan
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i31_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i31_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan program pengelolaan kesehatan kerja tahun terakhir
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i31_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i31_4', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.3.2</td>
        <td class="col-5">PENGELOLAAN KELELAHAN</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan program terkait pengelolaan kelelahan di tempat kerja tahun
          terakhir
        </td>
        <td class="col-1">4</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i32_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i32_1', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.3.3</td>
        <td class="col-5">PENGELOLAAN ERGONOMI</td>
        <td class="col-1">2</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur pengelolaan ergonomi</td>
        <td class="col-1">1</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i33_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i33_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">Lampirkan salinan hasil inspeksi ergonomi</td>
        <td class="col-1">1</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i33_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i33_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.3.4</td>
        <td class="col-5">PENGELOLAAN HIGIENE</td>
        <td class="col-1">3</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur pengelolaan higiene</td>
        <td class="col-1">1</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i34_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i34_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan kompetensi petugas higiene industri yang ditunjuk perusahaan
        </td>
        <td class="col-1">1</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i34_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i34_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan program pengelolaan higiene yang terakhir
        </td>
        <td class="col-1">1</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i34_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i34_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.4</td>
        <td class="col-5">PENGELOLAAN LINGKUNGAN KERJA</td>
        <td class="col-1">5</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait pengelolaan lingkungan kerja
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i4_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i4_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan salah satu analisa risiko terkait lingkungan kerja
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i4_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i4_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan program pengelolaan lingkungan kerja yang terakhir
        </td>
        <td class="col-1">1</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i4_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i4_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.5</td>
        <td class="col-5">PENGELOLAAN KESELAMATAN OPERASI</td>
        <td class="col-1">22</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.5.1</td>
        <td class="col-5">TENAGA TEKNIS</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan rincian tenaga teknis yang dimiliki perusahaan (jumlah serta
          tugas & tanggung jawabnya).
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i51_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i51_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan bukti kompetensi tenaga teknis (minimal 2).
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i51_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i51_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.5.2</td>
        <td class="col-5">SARANA PRASARANA, INSTALASI & PERALATAN</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar sarana, prasarana, instalasi dan peralatan (SPIP)
          yang dimiliki perusahaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan prosedur pemeliharaan untuk setiap jenis SPIP.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          "Lampirkan salinan program pemeliharaan rutin SPIP (minimal untuk 4
          jenis SPIP). Jika program pemeliharaan dilakukan oleh pihak ketiga,
          jelaskan pihak ketiga yang melakukan pemeliharaan rutin SPIP."
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.5.3</td>
        <td class="col-5">PENGAMANAN INSTALASI</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan hasil identifikasi kebutuhan pengamanan untuk
          instalasi (contoh: instalasi listrik, pneumatik/hidrolik, bahan bakar
          cair, air, komunikasi, proteksi kebakaran, gas).
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i53_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i53_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan 1 (satu) salinan evaluasi sistem pengamanan instalasi.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i53_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i53_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.5.4</td>
        <td class="col-5">KELAYAKAN SPIP</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur pengujian kelayakan SPIP.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i54_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i54_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">Lampirkan salinan standar kelayakan SPIP.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i54_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i54_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan pelaksanaan uji kelayakan SPIP (minimal 3 buah).
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i54_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i54_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.6</td>
        <td class="col-5">SISTEM IZIN KERJA</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait izin kerja khusus. Jika prosedur tidak ada,
          lampirkan semua jenis formulir izin kerja khusus.
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i6_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i6_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan formulir izin kerja khusus yang pernah dilakukan.
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i6_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i6_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.7</td>
        <td class="col-5">PENGELOLAAN PERLINDUNGAN LINGKUNGAN</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait pengelolaan perlindungan lingkungan hidup.
        </td>
        <td class="col-1">4</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i7_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i7_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan dokumen izin lingkungan yang dimiliki perusahaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i7_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i7_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.8</td>
        <td class="col-5">PROSEDUR KERJA</td>
        <td class="col-1">9</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar seluruh prosedur pengendalian operasional yang
          dimiliki perusahaan (seluruh prosedur hingga Analisa Kerja Aman / JSA
          dan Instruksi Kerja Aman).
        </td>
        <td class="col-1">4</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">Lampirkan prosedur pengendalian dokumen.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan bukti sosialisasi prosedur pengendalian operasional
          kepada karyawan (minimal 3 bukti).
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.9</td>
        <td class="col-5">ALAT PELINDUNG DIRI</td>
        <td class="col-1">5</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur tentang penggunaan APD di perusahaan.
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i9_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i9_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan daftar distribusi semua jenis APD, baik APD umum
          maupun APD khusus untuk pekerjaan tertentu.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i9_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i9_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">J</td>
        <td class="col-5">KEJADIAN, KECELAKAAN & PENYELIDIKAN</td>
        <td class="col-1">8</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait kecelakaan dan penyelidikan kecelakaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil penyelidikan kecelakaan (minimal 2).
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan bukti kompetensi petugas yang melakukan penyelidikan
          kecelakaan
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan salinan bukti sosialisasi hasil penyelidikan kecelakaan
          kepada pekerja.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_4', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">K</td>
        <td class="col-5">STATISTIK KPLH</td>
        <td class="col-1">4</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan laporan kinerja KPLH perusahaan yang terakhir.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_k_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_k_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan penghargaan dalam bidang KPLH yang pernah didapatkan
          perusahaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_k_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_k_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">L</td>
        <td class="col-5">AUDIT INTERNAL</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur audit yang dimiliki perusahaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_l_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_l_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">Lampirkan program audit tahunan yang terakhir.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_l_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_l_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan laporan audit (eksternal / internal) yang terakhir.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_l_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_l_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">M</td>
        <td class="col-5">TINJAUAN MANAJEMEN</td>
        <td class="col-1">8</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur terkait tinjauan manajemen.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_m_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_m_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan bukti pelaksanaan rapat tinjauan manajemen yang
          terakhir.
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_m_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_m_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan risalah hasil rapat tinjauan manajemen yang
          terakhir.
        </td>
        <td class="col-1">3</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_m_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_m_3', '') }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          HASIL PENILAIAN TOTAL UNTUK KATEGORI
          {{
            kplh &&
              convertFromSkalaBesar(
                $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-')
              )
          }}
        </td>
        <td class="text-center">{{ totalResult }} %</td>
        <!-- <td class="text-center bg-success">LULUS PRAKUALIFIKASI</td> -->
        <td
          :class="
            `text-center ${
              finalResult && finalResult.indexOf('TIDAK') != -1
                ? 'bg-danger text-white'
                : 'bg-success'
            }`
          "
        >
          {{ finalResult }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: [
    'kplh',
    'finalResult',
    'totalResult',
    'penilaian',
    'bobot',
    'totalNilai',
  ],
}
</script>
